import { Component, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NotificationType } from 'src/app/shared/enums/notification-type.enum';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';

@Component({
	selector: 'app-recovery',
	templateUrl: './recovery.component.html',
	styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent {
	recoveryEmail = '';
	sendButtonClicked = false;
	successfullySent = false;
	unsuccessfullySent = false;
	notificationEmail : NotificationEmail;
	listNotificationType = NotificationType;
	sendMail = new SendEmail();

	constructor(private facade: FacadeService, private logger: LogService) {}

	// ngOnInit() {}

	sendPasswordRecovery(): void {
		this.sendButtonClicked = true;
		const email = this.recoveryEmail;
		this.recoveryEmail = '';

		this.facade.authenticationService.retrievePassword(email).subscribe({
			next: (succ) => {
				this.facade.notificationEmailService.getAllNotificationEmail().subscribe({
					next: (val) => {
						this.notificationEmail = val.find(x => x.type == this.listNotificationType.REINITIALISATION_MOT_DE_PASSE)
						this.sendMail.email = email;
						this.sendMail.notificationEmail = this.notificationEmail;
						this.sendMail.urlReinitPassword = succ.token;
						this.sendMail.user = succ.user;
						this.facade.notificationEmailService.sendEmail(this.sendMail).subscribe({
							complete: () =>{
								this.sendButtonClicked = false;
								this.successfullySent = true;
							}
						})
					}
				})
			},
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.log(
					'' + err.status + ' ' + err.error.message ? err.error.message : ''
				);
				this.sendButtonClicked = false;
				this.unsuccessfullySent = true;
			}
		});
	}

	closeAlerts(): void {
		this.sendButtonClicked = false;
		this.successfullySent = false;
		this.unsuccessfullySent = false;
	}
}
